import React from 'react';

const Total = (props) => {
  let subTotal = props.therapist.standard + props.nutritionist.standard;
  let total = subTotal;
  let installmentOne = Math.round(((total + 25) * .65) / 10) * 10
  let installmentTwo = total + 25 - installmentOne
  let isInstallments = props.payment.value === 'installments';

  return (
    <div className="text-center">
      {subTotal ?
        <>
          <div className="price-calc__result">
            <div className="price-calc__subtotal font-weight-bold text-uppercase">
              Programme Cost £{subTotal}
            </div>
          </div>
          {isInstallments &&
            <>
              <div className="price-calc__installments">
                <div className="price-calc__installment">
                  <div className="small text-uppercase">Installment 1</div>
                  <div className="lead font-weight-bold">£{installmentOne}</div>
                </div>
                <div className="price-calc__installment">
                  <div className="small text-uppercase">Installment 2</div>
                  <div className="lead font-weight-bold">£{installmentTwo}</div>
                </div>
              </div>
              <hr className="mb-1" />
              <div className="d-flex justify-content-between small font-weight-bold text-uppercase">
                <div>Installments total</div>
                <div>£{installmentOne + installmentTwo}</div>
              </div>
            </>
          }
        </>
        :
        <div className="alert alert-info small text-left"><div className="font-weight-bold">{props.therapist.name} does not offer off-peak sessions.</div> Please change session times to standard or select another therapist.</div>
      }
    </div>
  );
}

export default Total;